import Button from '../button'
import OTPInput from '../otpInput'
import { Form } from 'antd'
import { useCountdown, useModal } from 'hooks'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { convertTimeSecondsToMinuteSeconds } from 'utils'

const StyledFooter = styled.div`
  display: flex;
  justify-content: end;
  gap: 12px;
  background-color: var(--color-gray-101);
  padding: 12px;
`
const StyledHeader = styled.div`
  padding: 24px;
  text-align: center;
`
const StyledCountDown = styled.div`
  font-weight: 700;
  font-size: 2.4rem;
  padding: 12px;
`
const StyledPhone = styled.div`
  font-weight: 700;
  font-size: 1.6rem;
  margin-bottom: 12px;
`

const StyledFormItemOtp = styled(Form.Item)`
  .ant-input:focus {
    border: none !important;
    box-shadow: none !important;
    border-bottom: 2px solid var(--color-primary-primary) !important;
  }
`

const StyledError = styled.div`
  font-weight: 500;
  font-size: 1.4rem;
  margin-bottom: 12px;
  color: var(--color-red-107);
  text-align: center;
`
interface IProps {
  onSubmit?: (opt: string) => Promise<any>
  timeCountDown: number
  phoneNumber?: string
  length?: number
  loading?: boolean
}
const OTPAuthentication = (props: IProps) => {
  const { timeCountDown, phoneNumber, length = 6, onSubmit } = props
  const [loading, setLoading] = useState(false)
  const { close } = useModal()
  const { timer } = useCountdown(timeCountDown, true, () => close())
  const { t } = useTranslation()
  const [opt, setOtp] = useState('')
  const [isValid, setIsValid] = useState(true)
  const handleFinish = async () => {
    const values = opt
    const valid = values?.length === length
    setIsValid(valid)
    if (valid) {
      setLoading(true)
      onSubmit && (await onSubmit(values))
      setLoading(false)
    }
  }
  return (
    <>
      <StyledHeader>
        <div>{t('verification-codes')}</div>
        <StyledCountDown>
          {convertTimeSecondsToMinuteSeconds(timer)}
        </StyledCountDown>
        <div>{t('send-verification-codes-to-phone')}</div>
        <StyledPhone>{phoneNumber}</StyledPhone>
      </StyledHeader>

      <StyledFormItemOtp name="otp">
        <OTPInput
          length={6}
          isValid={isValid}
          onChange={(value) => {
            setOtp(value)
            setIsValid(true)
          }}
        />
      </StyledFormItemOtp>
      {!isValid && <StyledError>{t('otp-invalid')}</StyledError>}

      <StyledFooter>
        <Button size="small" color="gray" onClick={() => close()}>
          {t('close')}
        </Button>
        <Button
          size="small"
          color="green"
          onClick={handleFinish}
          loading={loading}>
          {t('confirm')}
        </Button>
      </StyledFooter>
    </>
  )
}

export default OTPAuthentication
